/**
 * Regex Test if String is camelCased
 * @function isCamelCase
 * @param {string} str
 * @return {boolean}
 */
const isCamelCase = (str) => {
  // Check if the string is empty or not a string
  if (typeof str !== 'string' || str.length === 0) {
    return false;
  }

  // Regex for camelCase strings:
  // ^[a-z]        - Starts with a lowercase letter
  // [a-zA-Z0-9]*  - Followed by zero or more alphanumeric characters
  // $             - Ends after these characters (no other symbols)
  return /^[a-z][a-zA-Z0-9]*$/.test(str);
};

export default isCamelCase;
